import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { emailValidator } from '../../../services/app-validators';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/shared/services/data.service';
// import { ToastrService } from 'ngx-toastr/toastr/toastr.service';

@Component({
  selector: 'molla-sign-in-dialog',
  templateUrl: './sign-in-dialog.component.html',
  styleUrls: ['./sign-in-dialog.component.scss']
})
export class SignInDialogComponent implements OnInit {
  loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private router: Router,
    private apiService: ApiService,
    private authService: AuthenticationService,
    private modalService: ModalService,
    // private toastrService: ToastrService,
    private toastrService: ToastrService,
  ) {}

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required, emailValidator]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      user_type: ['exclusive']
    });
  }

  isSubuser(): void {
    const email = this.loginForm.get('email')?.value;
    if (email && email.includes('+')) {
      this.loginForm.patchValue({ user_type: 'sub_user' });
    } else {
      this.loginForm.patchValue({ user_type: 'exclusive' });
    }
  }

  onLoginFormSubmit(formValue: any): void {
    // if (!this.loginForm.valid) {
    //   this.loginForm.markAllAsTouched();
    //   return;
    // }
    this.authService.exclusiveLogin(this.loginForm.value['email'], this.loginForm.value['password']).then(resolve => {
        if (resolve) {
       //  console.log('auth data ', resolve)
            this.toastrService.success('User Login Successfully');
            this.modalService.closeCashBack();
        } else {
       //  console.log('auth data ', resolve)
            this.toastrService.error('Invalid Login Credentials!');
        }
    });
 //  console.log('form submit ', this.loginForm.value)
  }

  openDialog(): void {
    this.close();
  }

  goToDemoRequest(): void {
    this.activeModal.close();
    this.router.navigate(['/exclusive'], { queryParams: { view: 'demoRequest' } });
  }

  close(): void {
    this.activeModal.close();
  }
}
